// Playing-card faces: labels for the DOM hand, textures for the 3D table.
import * as THREE from 'three';

export const SUIT_GLYPH: Record<string, string> = { S: '♠', H: '♥', D: '♦', C: '♣' };
export const SUIT_NAME: Record<string, string> = { S: 'spades', H: 'hearts', D: 'diamonds', C: 'clubs' };
export const isRed = (card: string) => card[1] === 'H' || card[1] === 'D';
export const rankLabel = (card: string) => (card[0] === 'T' ? '10' : card[0]);
export const cardLabel = (card: string) => `${rankLabel(card)}${SUIT_GLYPH[card[1]]}`;
const RANK_WORD: Record<string, string> = { A: 'Ace', K: 'King', Q: 'Queen', J: 'Jack', T: '10' };
export const cardName = (card: string) => `${RANK_WORD[card[0]] ?? card[0]} of ${SUIT_NAME[card[1]]}`;

const cache = new Map<string, THREE.CanvasTexture>();

/** Card face texture (cached). `back` draws the card back. */
export function cardTexture(card: string | 'back'): THREE.CanvasTexture {
  const hit = cache.get(card);
  if (hit) return hit;
  const W = 160, H = 224;
  const c = document.createElement('canvas');
  c.width = W; c.height = H;
  const g = c.getContext('2d')!;
  const r = 16;
  g.beginPath();
  g.moveTo(r, 0); g.arcTo(W, 0, W, H, r); g.arcTo(W, H, 0, H, r); g.arcTo(0, H, 0, 0, r); g.arcTo(0, 0, W, 0, r);
  g.closePath();
  if (card === 'back') {
    g.fillStyle = '#123a5a'; g.fill();
    g.strokeStyle = '#00c2b3'; g.lineWidth = 6; g.stroke();
    g.strokeStyle = 'rgba(0,194,179,0.35)'; g.lineWidth = 2;
    for (let i = -H; i < W + H; i += 16) { g.beginPath(); g.moveTo(i, 0); g.lineTo(i + H, H); g.stroke(); }
  } else {
    g.fillStyle = '#fbfaf6'; g.fill();
    g.strokeStyle = '#c9c4b8'; g.lineWidth = 3; g.stroke();
    const col = isRed(card) ? '#c8102e' : '#16181d';
    g.fillStyle = col;
    g.textAlign = 'left'; g.textBaseline = 'top';
    g.font = 'bold 46px "Outfit", system-ui, sans-serif';
    g.fillText(rankLabel(card), 14, 10);
    g.font = '38px system-ui, sans-serif';
    g.fillText(SUIT_GLYPH[card[1]], 16, 58);
    g.textAlign = 'center'; g.textBaseline = 'middle';
    g.font = '104px system-ui, sans-serif';
    g.fillText(SUIT_GLYPH[card[1]], W / 2 + 12, H / 2 + 20);
  }
  const tex = new THREE.CanvasTexture(c);
  tex.colorSpace = THREE.SRGBColorSpace;
  tex.anisotropy = 4;
  cache.set(card, tex);
  return tex;
}
